import { render, staticRenderFns } from "./VBtnSalvar.vue?vue&type=template&id=29b88c6c&"
import script from "./VBtnSalvar.vue?vue&type=script&lang=js&"
export * from "./VBtnSalvar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports